<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <dx-data-grid
        v-if="!loading"
            class="dx-card content-block"
            :data-source="dataSource"
            key-expr="id"
            :focused-row-index="0"
            :show-borders="false"
            :focused-row-enabled="true"
            :column-auto-width="true"
            :column-hiding-enabled="true"
        >
        <dx-paging :page-size="20" />
        <dx-pager
            :show-page-size-selector="true"
            :show-info="true"
            :allowed-page-sizes="[5, 10, 20, 30, 50]"
        />
        <dx-filter-row :visible="true" />

        <dx-column data-field="name" caption="Domain Name" />
        <dx-column data-field="status" caption="Status" />
        <dx-column data-field="paused" caption="Paused" cell-template="pausedCell" />
        <dx-column data-field="type" caption="Certificate Type" />

        <!-- Newly added columns -->
        <dx-column data-field="original_registrar" caption="Original Registrar" />
        <dx-column data-field="created_on" caption="Created On" data-type="date" format="yyyy-MM-dd" />
        <dx-column data-field="activated_on" caption="Activated On" data-type="date" format="yyyy-MM-dd" />
        <dx-column data-field="modified_on" caption="Modified On" data-type="date" format="yyyy-MM-dd" />

        <template #pausedCell="{ data }">
            <span :class="['tag-pill', data.value ? 'tag-warning' : 'tag-ok']">
            {{ data.value ? 'Yes' : 'No' }}
            </span>
        </template>
    </dx-data-grid>
    

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxFilterRow
} from 'devextreme-vue/data-grid';

import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import axios from 'axios';  

export default {
  name: 'CertificatesGrid',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxLoadIndicator
  },
  data() {
    return {
      title: 'Cloudflare DNS Records',
      loading: true,
      dataSource: []
    };
  },
  mounted() {
    this.loadCertificates();
  },
  methods: {
    async loadCertificates() {
      try {
        const response = await axios.get('/api/internal/cloudflare/dns-zones');
        // const json = await res.json();
        // this.dataSource = json;
        this.dataSource = Array.isArray(response.data) ? response.data : [];
      } catch (err) {
        console.error('Error loading data:', err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
}

.tag-pill {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: white;
}

.tag-ok {
  background-color: #4caf50;
}

.tag-warning {
  background-color: #ff9800;
}
</style>
